import { render } from "./SecondKillOrder.vue?vue&type=template&id=120c4da4&scoped=true"
import script from "./SecondKillOrder.vue?vue&type=script&lang=js"
export * from "./SecondKillOrder.vue?vue&type=script&lang=js"

import "./SecondKillOrder.vue?vue&type=style&index=0&id=120c4da4&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120c4da4"]])

export default __exports__